<!-- 转赠明细 -->
<template>
    <div class="jifenDetailPage">
      <!-- header start -->
      <van-nav-bar
        title="转换明细"
        fixed
        :placeholder="true"
        :z-index="99"
        left-arrow
        @click-left="goBack"
      />
      <!-- header end -->
  
      <div class="selectdate-box" @click="jifenDateShow = true">
        <div class="lable-box">
          <img src="~@/assets/images/clock-icon.png" alt="" class="icon" />
          <span class="title">日期</span>
        </div>
        <div class="input-control">{{ date }}</div>
        <van-icon name="arrow" size="12" color="#999" />
      </div>
      <div class="member-body">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            :offset="offset"
            finished-text="没有更多了"
            @load="loadMore"
          >
            <div v-for="(item, i) in dataList" :key="i" class="member-item">
              <div class="th">
                <img :src="item.HeadPic" alt="" class="avatar" />
              </div>
              <div class="bd">
                <div class="name">{{ item.NickName }}</div>
                <div class="date">交易时间{{ item.AddDateTime }}</div>
              </div>
              <div class="ft">
                <div v-if="item.ChangeTypeId == 1" class="price">
                  转换余额{{ item.Price }}到积分！
                </div>
                <div v-else class="price">
                  转换积分{{ item.Price }}到余额！
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
  
      <!-- 日历 popup start -->
      <van-calendar
        v-model="jifenDateShow"
        type="range"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
      />
      <!-- 日历 popup end -->
    </div>
  </template>
  
  <script>
  import common from "../../../tools/common";
  
  import { Calendar } from "vant";
  export default {
    data() {
      return {
        options: {
          type: "TransactionDetailTurnCashList",
          PageIndex: 1
        },
        date: "",
        minDate: new Date(2019, 0, 1),
        maxDate: new Date(),
        currentDate: new Date(),
        jifenDateShow: false,
        tabActive: 0,
        beginTime: "",
        endTime: "",
        offset: 100,
        refreshing: false,
        loading: true,
        finished: false,
        dataList: []
      };
    },
    components: {
      [Calendar.name]: Calendar
    },
    methods: {
      init() {
        this.getList();
      },
      goBack() {
        this.$router.go(-1);
      },
      formatDate(date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      },
      onConfirm(date) {
        const [start, end] = date;
        this.jifenDateShow = false;
        this.date = `${this.formatDate(start)} ~ ${this.formatDate(end)}`;
        var _beginTime = this.formatDate(start);
        var _endTime = this.formatDate(end);
        Object.assign(this.options, {
          PageIndex: 1,
          beginTime: _beginTime,
          endTime: _endTime
        });
        this.getList();
      },
      onRefresh() {
        this.finished = false;
        this.loading = true;
        Object.assign(this.options, {
          PageIndex: 1
        });
        this.getList();
      },
      loadMore() {
        Object.assign(this.options, {
          PageIndex: this.options.PageIndex + 1
        });
        this.loading = true;
        this.getList();
      },
      getList() {
        var that = this;
        this.$store.dispatch(this.options).then(
          res => {
            console.log(res,"getList");
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }
            common.Response.callNotMsgResponse(res, function(result) {
              console.log(result);
              if (result.data.length <= 0) {
                that.finished = true;
              }
              if (that.options.PageIndex > 1) {
                if (result.data.length > 0) {
                  result.data.forEach(element => {
                    that.dataList.push(element);
                  });
                }
              } else {
                that.dataList = result.data;
              }
            });
          },
          error => {
            console.log(error);
          }
        );
      }
    },
    created() {
      this.init();
    }
  };
  </script>
  <style lang="less" scoped>
  .jifenDetailPage {
    padding-bottom: 10px;
  }
  .selectdate-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 12px;
    display: flex;
    align-items: center;
    .lable-box {
      display: flex;
      align-items: center;
      .icon {
        width: 16px;
        height: 16px;
        object-fit: contain;
        margin-right: 10px;
      }
      .title {
        font-size: 16px;
        color: #333;
      }
    }
    .input-control {
      flex: 1;
      overflow: hidden;
      text-align: right;
      font-size: 14px;
      color: #333;
      margin-right: 8px;
    }
  }
  .tongji-section {
    margin: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .col {
      width: 49%;
      background: #fff;
      border-radius: 8px;
      padding: 15px 6px;
      height: 100px;
      .tongji-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        height: 100%;
        .price-box {
          font-size: 12px;
          color: #2b2b2b;
          .price {
            font-size: 22px;
            font-weight: bold;
          }
        }
        .des {
          font-size: 14px;
          color: #7c7c7c;
        }
      }
    }
  }
  .jifen-box {
    margin: 10px;
    background: #fff;
    border-radius: 8px;
    padding: 15px 0;
  }
  //转赠item
  .zhuan-item-box {
    margin: 0 10px;
    border-bottom: 1px solid #dedede;
    padding: 14px 0;
    .zhuan-item {
      display: flex;
      align-items: center;
      & > .left-user {
        justify-content: flex-end;
        .bd {
          margin-right: 8px;
          text-align: right;
          overflow: hidden;
          flex: 1;
        }
      }
      & > .right-user {
        .bd {
          margin-left: 8px;
          overflow: hidden;
          flex: 1;
        }
      }
      .u-name {
        font-size: 13px;
        color: #000000;
      }
      .u-date {
        font-size: 12px;
        color: #ababab;
        white-space: nowrap;
      }
      .u-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
      }
      & > .mid-box {
        width: 40px;
        text-align: center;
        margin: 0 10px;
        & > .des {
          font-size: 13px;
          color: #0a0a0a;
        }
        & > .arrow {
          height: 2px;
          background-color: #696969;
          width: 40px;
          display: block;
          margin-top: 2px;
          &.arrow-ru {
            &:after {
              border-color: #696969;
              border-style: solid;
              border-width: 2px 0 0 0;
              -webkit-transform: rotate(35deg);
              -ms-transform: rotate(35deg);
              transform: rotate(35deg);
              margin-top: -3px;
              width: 6px;
              height: 6px;
              display: block;
              float: right;
              content: "";
            }
          }
          &.arrow-chu {
            &:after {
              border-color: #696969;
              border-style: solid;
              border-width: 2px 0 0 0;
              -webkit-transform: rotate(-35deg);
              -ms-transform: rotate(-35deg);
              transform: rotate(-35deg);
              margin-top: -3px;
              width: 6px;
              height: 6px;
              display: block;
              float: left;
              content: "";
            }
          }
        }
        & > .price {
          font-size: 15px;
          color: #ea0000;
        }
      }
    }
    .beizhu {
      text-align: center;
      margin-top: 10px;
      font-size: 12px;
      color: #484848;
    }
  }
  .zhuan-item-box .zhuan-item > .left-user,
  .zhuan-item-box .zhuan-item > .right-user {
    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  
  //用户列表
  .member-item {
    display: flex;
    align-items: center;
    margin: 20px 10px;
    .th {
      margin-right: 12px;
      .avatar {
        height: 52px;
        width: 52px;
        object-fit: cover;
        border-radius: 50%;
      }
    }
    .bd {
      flex: 1;
      overflow: hidden;
      .name {
        font-size: 14px;
        color: #000;
      }
      .date {
        font-size: 12px;
        color: #ababab;
        margin-top: 6px;
      }
    }
    .ft {
      margin-left: 5px;
      text-align: right;
      .tag-box {
        text-align: right;
        font-size: 0;
        .tag-item {
          display: inline-block;
          font-size: 10px;
          color: #fff;
          height: 18px;
          line-height: 18px;
          padding: 0 6px;
          border-radius: 3px;
          background: #f3354f;
          margin-left: 4px;
        }
      }
      .price {
        font-size: 12px;
        color: #0a0a0a;
        margin-top: 4px;
      }
    }
  }
  .member-body {
    margin: 10px;
    padding: 15px;
    background: #fff;
    border-radius: 6px;
  }
  </style>
  